/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import apiClient from '../../lib/apiClient';

const fetchAppConstants = async (): Promise<any> => {
  const response: AxiosResponse<any> = await apiClient.get(`/constants`, {
    params: {
      key: `hospital`,
    },
  });

  return response?.data?.data ?? null;
};

const useFetchAppConstants = () => {
  return useQuery<any>({
    queryKey: ['constants'],
    queryFn: () => fetchAppConstants(),
  });
};

export default useFetchAppConstants;
